// Jokes side content
export const jokesArr = [
  "Type in a topic sentence between 5 and 25 words long.",
  "Click “Get Witscript’s responses.”",
  "Witscript responds with some suggested jokes and picks its favorite.",
  "Click again for more responses to the same sentence. Or enter a new sentence.",
  "Need more help? See the FAQ below.",
];

export const punchJokeArr = [
  "Type in a joke between 10 and 60 words long.",
  "Only have part of a joke? Type it in using \"[BLANK]\" for the missing part.",
  "Click \"Punch it up!\"",
  "Witscript suggests some improved versions.",
  "If your original is already good, Witscript may include it as one of the options.",
];

export const witraterArr = [
  "Type in a joke between 10 and 60 words long.",
  "Click \"Rate that joke!\"",
  "Witrater scores it on the scale below and explains its rating.",
];

export const getSetupsArr = [
  "Want setups for writing topical jokes?",
  "Click \"Get setups!\"",
  "Witscript suggests some joke setups based on current news.",
  "Copy/paste one into Write a Joke.\nOr click again for more setups.",
  "Witscript delivers fresh setups all day.",
  "But they may not be 100% accurate or appropriate, so fact-check them!",
];